<template lang="html">
  <div id="home-page">


    <section class="container-fluid banner-section">
      <swiper class="swiper-desktop" :options="bannersOption">
        <swiper-slide v-if="banner.device == 'pc'" v-for="(banner, index) in banners" :key="index">
          <div class="d-block placed-backg" v-bind:style="{ backgroundImage: 'url('+banner.imageUrl+')' }">
            <img src="public/images/pages/home/banner.png">
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <swiper class="swiper-mobile" :options="bannersOption">
        <swiper-slide v-if="banner.device == 'movil'" v-for="(banner, index) in banners" :key="index">
          <div class="d-block placed-backg" v-bind:style="{ backgroundImage: 'url('+banner.imageUrl+')' }">
            <img src="public/images/pages/home/banner-m.png">
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>

    <section class="container oversized-container products-section">
      <div class="row">
        <div class="col-12 col-s-title">
          <h2 class="title">Lo más vendido</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
            <swiper-slide v-for="(product, prhInx) in products" :key="'prhInx-'+prhInx">
              <div class="col-12 px-0 sample-product shad-prod">
                <div class="outlined-box">
                  <router-link class="box-image" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                    <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.img+')' }">
                      <img src="public/images/shared/empty.png" >
                    </div>
                  </router-link>

                  <div class="box-shot-descr">
                    <h6 class="brand">{{ product.sku }}</h6>
                    <h6 class="name">{{ product.name }}</h6>
                    <h6 class="price discount" v-if="product.oferta == 1"><span>$ {{ product.price_org }}</span></h6>
                    <h6 class="price">{{ product.price }}</h6>
                    <h6 class="brand" style="font-size: 15px;color: #1b5985;">Existencias ({{ product.stock }})</h6>
                  </div>
                  <p class="p-button">
                    <router-link class="btn-more" :to="'/producto/'+$root._converToURL(product.name, product.id)">Ver más</router-link>
                  </p>

                  <cart-express-component class="mb-4" :obj="{ id: product.id, name: product.name, modelo: product.modelo_id, stock: product.stock, image: product.img }"></cart-express-component>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>

    <!-- <section class="categories-section">
      <div class="container oversized-container">
        <div class="row justify-content-center">
          <div class="col-12 col-title">
            <h2>CATEGORÍAS</h2>
          </div>

          <div class="col-md-6 col-lg-4 col-xl-3 col-info" v-for="(category, chInx) in categories" :key="'hc-'+chInx">
            <router-link class="box-info" v-bind:style="{ backgroundImage: 'url('+category.img+')' }" to="/productos">
              <img class="img" :src="category.img">

              <div class="inside">
                <h5>{{ category.name }}</h5>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section> -->

    <section class="container oversized-container pb-4 products-section">
      <div class="row">
        <div class="col-12 col-s-title">
          <h2 class="title">Promociones del mes</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1 ct1-white" :options="promotionsOption">
            <swiper-slide v-for="(oferta, index) in ofertas" :key="index">
              <div class="col-12 px-0 sample-product shad-prod">
                <div class="outlined-box">
                  <a class="box-image" :href="oferta.url" target="_blank">

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+oferta.imageUrl+')' }">
                      <img src="public/images/shared/empty.png" >
                    </div>
                  </a>
                  <p class="p-button">
                    <router-link class="btn-more" :to="'/promociones/'+oferta.id">Ver productos</router-link>
                  </p>


                </div>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>

    <!-- <section class="info-section">
      <div class="container oversized-container">
        <div class="row justify-content-center">
          <div class="col-lg-11">
            <div class="row justify-content-between">
              <div class="col-lg-3 col-info">
                <h5 class="title">Particular</h5>

                <div class="box-icon">
                  <img src="public/images/pages/home/icon-particular.svg">
                </div>

                <ul>
                  <li>Compras desde 1 pieza.</li>
                  <li>Somos productores, garantizamos tu entrega en tiempo y forma.</li>
                  <li>Forma de pago variadas.</li>
                  <li>Puedes bordar el logo de tu empresa.</li>
                </ul>
              </div>

              <div class="col-lg-3 col-info">
                <h5 class="title">Distribuidores</h5>

                <div class="box-icon">
                  <img src="public/images/pages/home/icon-distribuidores.svg">
                </div>

                <ul>
                  <li>Conviértete en distribuidor de la marca líder en calidad de moda corporativa.</li>
                  <li>Somos fabricantes, te damos el mejor precio.</li>
                </ul>
              </div>

              <div class="col-lg-3 col-info">
                <h5 class="title">Empresas</h5>

                <div class="box-icon">
                  <img src="public/images/pages/home/icon-empresas.svg">
                </div>

                <ul>
                  <li>A partir de 25 piezas.</li>
                  <li>Mejoramos el precio a mayor volumen.</li>
                  <li>Producimos la cantidad que necesites.</li>
                  <li>Puedes bordar el logo de tu empresa.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section class="mission-section">
      <div class="box">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-10 col-info">
              <h5 class="title">Misión</h5>
              <p>
                Brindar soluciones integrales en productos y servicios de ferretería y de construcción excediendo las expectativas de empresas, constructoras y público en general.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="container oversized-container pb-4 brands-section">
      <div class="row">
        <div class="col-12 col-s-title">
          <h2 class="title">Distribuidores Autorizados</h2>
        </div>

        <div class="col-12 col-brands">
          <swiper class="swiper" :options="brandsOptions">
            <swiper-slide v-for="(brand, brhInx) in brands" :key="'brhInx-'+brhInx">
              <div class="box-brand">
                <div class="inside">
                  <router-link class="outlined-box" :to="'/marca/'+$root._converToURL(brand.name, brand.id)">
                    <img :src="brand.imageUrl">
                  </router-link>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>

    </section>

    <b-modal modal-class="modal-image" ref="modal-home" size="lg" title="" centered hide-footer>
      <img :src="bannermodal">
    </b-modal>

  </div>
</template>

<script>
export default {
  data(){
    return{
      banners: [],
      products: [],
      ofertas: [],
      categories: [
        { img: 'public/images/pages/home/category-1.jpg', name: 'Camisa - Caballero' },
        { img: 'public/images/pages/home/category-2.jpg', name: 'Blusa - Dama' },
        { img: 'public/images/pages/home/category-3.jpg', name: 'Pantalón - Dama' },
        { img: 'public/images/pages/home/category-4.jpg', name: 'Pantalón - Caballero' },
      ],
      brands: [],

      /* == Carousel options == */
      bannersOption: {
        loop: false,
        speed:800,
        effect: 'fade',

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
      },

      productsOption: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1399: {
            slidesPerView: 5
          },
          1199: {
            slidesPerView: 4
          },
          991: {
            spaceBetween: 30,
            slidesPerView: 3
          },
          575: {
            spaceBetween: 20,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      promotionsOption: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1399: {
            slidesPerView: 5
          },
          1199: {
            slidesPerView: 4
          },
          991: {
            spaceBetween: 30,
            slidesPerView: 3
          },
          575: {
            spaceBetween: 20,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      brandsOptions: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },

        breakpoints: {
          1200: {
            slidesPerView: 5,
          },
          992: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          400: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },
      // == ==
      bannermodal:null,
      banner_status:null
    }
  },

  methods: {
    getHome: function(){
        axios.get(tools.url('/api/home')).then(({data}) =>{
            this.banners = data.banners;
            this.products = data.destacados;
            this.ofertas = data.ofertas;
            this.brands = data.marcas;
            this.bannermodal = data.banner;
            this.banner_status = data.banner_status;
            if (this.banner_status == 1) {
                this.$refs['modal-home'].show();
            }
        });
    }
  },

  mounted(){
    this.getHome();


  }

}
</script>
